import { defineRouting } from 'next-intl/routing';
import { DEFAULT_LOCALE, LOCALES } from './config';

/**
 * next-intl routing definition, derived from config.ts. Used only by the
 * navigation helpers (locale-aware Link/redirect). Detection and redirects
 * live in src/proxy.ts, not in next-intl's middleware — its cookie policy
 * (persist whatever locale was last visited) would let a direct link change a
 * visitor's saved preference, which Documentation/13 §2.3 forbids.
 */
export const routing = defineRouting({
  locales: LOCALES,
  defaultLocale: DEFAULT_LOCALE,
  // The default language lives at the bare path ("/standings"); only other
  // languages carry a prefix ("/es/standings"). With every other language
  // paused (config.ts) that means no prefixes at all — and it keeps English
  // URLs stable when they come back.
  localePrefix: 'as-needed',
  localeCookie: false,
  localeDetection: false,
  alternateLinks: false,
});
